// @ts-nocheck
import * as React from "react";

const BatteryFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M15.83 6A2.31 2.31 0 0118 8.43v7.14A2.31 2.31 0 0115.83 18H4.17A2.31 2.31 0 012 15.57V8.43A2.31 2.31 0 014.17 6zM21 9l.117.007A1 1 0 0122 10v4a1 1 0 11-2 0v-4l.007-.117A1 1 0 0121 9z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BatteryFill);
